import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { PermissionService, AccessLevel } from '../services/permission.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  constructor(private perms: PermissionService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | boolean | UrlTree {
    const module = route.data['module'] as string | undefined;
    if (!module) return true;

    // Optional required level — routes that mutate data set access: 'MANAGE'
    // so a view-only user is bounced to /no-access (e.g. /trips/:id/edit).
    const required = (route.data['access'] as AccessLevel) ?? 'VIEW';

    // Admin bypass — no need to wait for permission load
    if (this.perms.isAdmin) return true;

    // Wait until perms$ emits a real map (not null = still loading)
    return this.perms.permissions$.pipe(
      filter(p => p !== null),
      take(1),
      map(p => {
        const acc = (p ?? {})[module] ?? 'NONE';
        const allowed = required === 'MANAGE'
          ? acc === 'MANAGE'
          : acc === 'VIEW' || acc === 'MANAGE';
        return allowed ? true : this.router.createUrlTree(['/no-access'], { queryParams: { module } });
      }),
    );
  }
}
